import React from "react";
import factoryImage from "../images/factory (2).jpg";
import { Typewriter } from "react-simple-typewriter";

const HomeWhoAreWe = () => {
  return (
    <div id="about" className="py-20">
      {/* Section Header */}
      <div className="text-center max-w-3xl mx-auto mb-16" data-aos="fade-up">
        <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
          About Company
        </span>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
          WHO ARE WE?
        </h2>
      </div>

      {/* Grid: Image & Story */}
      <div className="grid gap-12 lg:grid-cols-2 items-center">
        {/* Left: Factory Image Card */}
        <div className="relative group" data-aos="fade-right">
          <div className="overflow-hidden rounded-2xl shadow-xl border border-slate-200/80 bg-slate-900">
            <img
              src={factoryImage}
              alt="The Dynamic Exim Factory"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 opacity-90"
            />
          </div>

          {/* Experience Badge */}
          <div className="bg-white/95 backdrop-blur-md shadow-2xl border border-slate-100 p-4 sm:p-5 rounded-2xl absolute z-20 -bottom-6 -right-4 sm:right-6 flex items-center gap-3">
            <span className="text-[#EB4438] text-4xl sm:text-5xl font-extrabold tracking-tight">
              8+
            </span>
            <p className="font-bold text-xs sm:text-sm text-slate-800 uppercase tracking-wider leading-tight">
              YEARS OF <br /> EXPERIENCE
            </p>
          </div>

          {/* Typewriter Overlay */}
          <div className="absolute inset-0 z-10 flex items-center justify-center p-6 bg-gradient-to-t from-[#0B2239]/90 via-[#0B2239]/50 to-transparent rounded-2xl pointer-events-none">
            <p className="text-white text-xl md:text-3xl font-extrabold text-center drop-shadow-md">
              <Typewriter
                words={["The Dynamic Export Import LTD"]}
                loop={""}
                cursor
                cursorStyle="_"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </p>
          </div>
        </div>

        {/* Right: Company Description */}
        <div className="space-y-5 text-slate-600 leading-relaxed text-sm sm:text-base" data-aos="fade-left">
          <p className="text-justify">
            <span className="font-semibold text-slate-900 border-l-4 border-[#EB4438] pl-3 inline-block mb-2">
              The Dynamic Export Import Company Ltd. started its operation in
              Bangladesh in the year 2017.
            </span>{" "}
            Its initial role was to source for competitive but quality priced
            garments accessories commodities for the domestic market to support
            Bangladesh's. Within a very short time the company was able to
            establish business partnership with some of the leading manufacturers
            from{" "}
            <span className="font-semibold text-slate-900 underline decoration-[#EB4438] decoration-2">
              Europe, USA & Canada
            </span>{" "}
            working as a local agent in Bangladesh supplying quality products.
            Later on, the company created export markets for locally manufactured
            products, and promote external trade.
          </p>

          <p className="text-justify">
            “Dynamic” that could be materialized as "A Single Source Solution"
            from. Manufacturing, export, import, local distribution, commissioning
            & after sales services. Our sincere thanks & great appreciation to our
            prestigious clients for their generous support & cooperation that has
            led to this achievement. We are always open to opportunities and look
            forward in providing you with even a greater range of products and
            more efficient services to your specific requirements. May our goal
            become more fruitful so do our potential & valued clients become more
            satisfied with our quality products & our services and that would be
            the greatest achievements of all which we look forward to in the days
            to come.
          </p>
        </div>
      </div>

      {/* Leadership / Officials Header */}
      <div className="text-center max-w-3xl mx-auto mt-28 mb-16" data-aos="fade-up">
        <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
          Executive Leadership
        </span>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
          Meet Our Officials
        </h2>
      </div>

      {/* Leadership Profile */}
      <div className="grid gap-12 md:grid-cols-2 items-center bg-slate-50 border border-slate-200/80 rounded-3xl p-6 sm:p-10 lg:p-12 shadow-sm">
        {/* Photo Card */}
        <div className="relative group overflow-hidden rounded-2xl shadow-xl border border-slate-200" data-aos="fade-right">
          <img
            src="https://i.ibb.co/1KnHXz2/moin2.jpg"
            alt="Abdullah Al-Moin - Managing Director"
            className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {/* Bottom Dark Overlay Gradient for High Contrast */}
          <div className="absolute inset-x-0 bottom-0 pt-28 pb-6 px-6 bg-gradient-to-t from-black via-black/80 to-transparent flex flex-col justify-end">
            <p
              className="text-white font-extrabold text-2xl sm:text-3xl tracking-tight drop-shadow-md"
              style={{ textShadow: "0 2px 10px rgba(0,0,0,0.9)" }}
            >
              Abdullah Al-Moin
            </p>
            <p
              className="text-[#FF6B5E] font-bold text-sm sm:text-base tracking-wider uppercase mt-1 drop-shadow-md"
              style={{ textShadow: "0 2px 8px rgba(0,0,0,0.9)" }}
            >
              Managing Director
            </p>
          </div>
        </div>

        {/* Message */}
        <div
          className="text-justify text-slate-700 space-y-4 text-sm sm:text-base leading-relaxed"
          data-aos="fade-left"
        >
          <p>
            As an elastic business owner, I understand the importance of being
            flexible and adaptable in today's ever-changing business landscape. I
            believe that success in business comes not just from having a great
            product or service, but from having the ability to pivot and adjust
            your strategy when needed.
          </p>
          <p>
            Throughout my career, I have built a reputation for being able to
            navigate through uncertain times and come out stronger on the other
            side. Whether it's through exploring new markets, implementing
            innovative technologies, or simply finding creative solutions to
            everyday challenges, I am always looking for ways to stay ahead of the
            curve and drive my business forward.
          </p>
          <p className="hidden lg:block text-slate-600 border-t border-slate-200/80 pt-4">
            But being an elastic business owner isn't just about being agile and
            responsive - it's also about being resilient and determined. I
            believe that with hard work, persistence, and a willingness to take
            calculated risks, anyone can achieve their goals and make their
            business dreams a reality. <br />
            So whether you're a startup founder, a small business owner, or an
            established entrepreneur, I am here to help you navigate the
            challenges of the business world and achieve the success you
            deserve. Together, we can create a strategy that is both flexible
            and strong, allowing you to adapt and thrive no matter what the
            future holds.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomeWhoAreWe;
